import { render, staticRenderFns } from "./AuthLoadingCard.vue?vue&type=template&id=6ebddd44&scoped=true&lang=pug"
import script from "./AuthLoadingCard.vue?vue&type=script&lang=ts"
export * from "./AuthLoadingCard.vue?vue&type=script&lang=ts"
import style0 from "./AuthLoadingCard.vue?vue&type=style&index=0&id=6ebddd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebddd44",
  null
  
)

export default component.exports